import React, { useContext, useState, useEffect } from "react";
import Context from "../../../../context/context";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import moment from "moment";
import { travelTypeEnum } from "../../../../common/enum";
import { getStartDate } from "../../../../common/utils";
import { fetchRange2025 } from "../../../../apiCall";

const startOfLocalDay = (d) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};

const endOfPreviousLocalDay = (d) => {
  const x = new Date(d);
  x.setDate(x.getDate() - 1);
  x.setHours(23, 59, 59, 999);
  return x;
};

// props: { isInviteBack }
const DateHour = (props) => {
  const { state, dispatch } = useContext(Context);

  const [date, setDate] = useState(
    props.isInviteBack ? state.dateBack : state.date
  );
  const [hour, setHour] = useState(
    props.isInviteBack ? state.hourBack : state.hour
  );

  const [minDate, setMinDate] = useState(null);
  const [maxDate, setMaxDate] = useState(null);
  const [firstEnabledDate, setFirstEnabledDate] = useState(null);

  const [disableDateFn, setDisableDateFn] = useState(() => () => false);

  const setDateDispach = (data) =>
    dispatch({
      type: props.isInviteBack ? "SET_DATE_BACK" : "SET_DATE",
      payload: data,
    });

  const setHourDispatch = (data) =>
    dispatch({
      type: props.isInviteBack ? "SET_HOUR_BACK" : "SET_HOUR",
      payload: data,
    });

  const setSpecificNoteDispatch = (data) =>
    dispatch({
      type: props.isInviteBack ? "SET_ORBIT_BACK_NOTE" : "SET_ORBIT_NOTE",
      payload: data,
    });

  const onChangeDate = (mVal) => {
    setSpecificNoteDispatch("");
    const jsDate = mVal && typeof mVal.toDate === "function" ? mVal.toDate() : null;
    if (jsDate) jsDate.setHours(0, 0, 0, 0);
    setDate(jsDate);
    setDateDispach(jsDate);
  };

  const onChangeMinutes = (mVal) => {
    const jsDate = mVal && typeof mVal.toDate === "function" ? mVal.toDate() : null;
    setHour(jsDate);
    setHourDispatch(jsDate);
  };

  const computeFirstEnabledDate = (from, disabler) => {
    const start = new Date(from);
    start.setHours(0, 0, 0, 0);
    const days = 370;
    for (let i = 0; i < days; i++) {
      const next = new Date(start.getTime() + i * 24 * 60 * 60 * 1000);
      if (!disabler(next)) {
        next.setHours(0, 0, 0, 0);
        return next;
      }
    }
    return null;
  };

  const getRegularSadirRanges = () => {
    if(!state.customerSettings || !state.customerSettings.regularSadirDates){
      setDisableDateFn(() => () => false);
      setMinDate(null);
      setMaxDate(null);
      setFirstEnabledDate(null);
      return;
    }
    // TODO continue implement
  }
  
  useEffect(() => {
    if(state.tripType !== travelTypeEnum.regularSadir){
      get2025RangeValue();
    } else{
      // if regular sadir- take ranges of enable regular for both sides
      getRegularSadirRanges();
    }
  }, [state.tripType]);

  const get2025RangeValue = () => {
    fetchRange2025((response) => {
      if (!response) {
        setDisableDateFn(() => () => false);
        setMinDate(null);
        setMaxDate(null);
        setFirstEnabledDate(null);
        return;
      }

      let startDateEdge = null;
      let endDateEdge = null;

      if (props.isInviteBack || state.side === "מאומן") {
        startDateEdge = response?.data?.fromUman?.start
          ? startOfLocalDay(response.data.fromUman.start)
          : null;
        endDateEdge = response?.data?.fromUman?.end
          ? endOfPreviousLocalDay(response.data.fromUman.end)
          : null;
      } else {
        startDateEdge = response?.data?.toUman?.start
          ? startOfLocalDay(response.data.toUman.start)
          : null;
        endDateEdge = response?.data?.toUman?.end
          ? endOfPreviousLocalDay(response.data.toUman.end)
          : null;
      }

      setMinDate(startDateEdge);
      setMaxDate(endDateEdge);

      const disableFn = (dayLike) => {
        if (!startDateEdge || !endDateEdge) return false;
        const d =
          dayLike && typeof dayLike.toDate === "function"
            ? dayLike.toDate()
            : new Date(dayLike);
        d.setHours(0, 0, 0, 0);
        return d < startDateEdge || d > endDateEdge;
      };

      setDisableDateFn(() => disableFn);

      const today = new Date();
      const first = computeFirstEnabledDate(today, disableFn);
      setFirstEnabledDate(first);

      const noForwardDate =
        (!props.isInviteBack && (state.date === "" || !state.date)) ||
        (props.isInviteBack && (state.dateBack === "" || !state.dateBack));

      if (noForwardDate) {
        if (state.isTrain) {
          const trainDatesObj = state.customerSettings && state.customerSettings.trainDates ? state.customerSettings.trainDates : null;
          const trainArr = state.side === 'לאומן'
            ? trainDatesObj && Array.isArray(trainDatesObj.forwardDates) ? trainDatesObj.forwardDates : []
            : trainDatesObj && Array.isArray(trainDatesObj.backwardDates) ? trainDatesObj.backwardDates : [];

          if (trainArr && trainArr.length > 0) {
            const rawTs = Number(trainArr[0]);
            const ms = String(Math.abs(rawTs)).length > 10 ? rawTs : rawTs * 1000;
            const trainDate = new Date(ms);
            trainDate.setHours(0, 0, 0, 0);
            setDate(trainDate);
            setDateDispach(trainDate);
          } else if (first) {
            setDate(first);
            setDateDispach(first);
          }
        } else {
          if (first) {
            setDate(first);
            setDateDispach(first);
          }
        }
      }
    });
  };

  const forwardUnixDates = state.side == 'לאומן' ? state.customerSettings.trainDates.forwardDates || [] : state.customerSettings.trainDates.backwardDates || [];

  const allowedDates = forwardUnixDates.map(ts => moment(ts));

  const isAllowedDate = (date) => {
    return allowedDates.some(allowed => allowed.isSame(date, 'day'));
  };

  const defaultCalendarMonthMoment = firstEnabledDate
    ? moment(firstEnabledDate)
    : date
      ? moment(date)
      : minDate
        ? moment(minDate)
        : null;

  return (
    <div>

      {state.isTrain ?
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <Stack spacing={3}>

            <MobileDatePicker
              label="תאריך"
              inputFormat="DD/MM/YYYY"
              value={date ? moment(date) : null}
              onChange={onChangeDate}
              disablePast={true}
              shouldDisableDate={(day) => !isAllowedDate(day)}
              defaultCalendarMonth={defaultCalendarMonthMoment}
              renderInput={(params) => (
                <TextField className="dateInput" {...params} error={false} />
              )}
            />
          </Stack>

        </LocalizationProvider>


        : <>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <Stack spacing={3}>
              <MobileDatePicker
                label="תאריך"
                inputFormat="DD/MM/YYYY"
                value={date ? moment(date) : null}
                onChange={onChangeDate}
                disablePast={true}
                shouldDisableDate={disableDateFn}
                defaultCalendarMonth={defaultCalendarMonthMoment}
                minDate={minDate ? moment(minDate) : undefined}
                maxDate={maxDate ? moment(maxDate) : undefined}
                openTo="day"
                renderInput={(params) => (
                  <TextField className="dateInput" {...params} error={false} />
                )}
              />

              {state.tripType === travelTypeEnum.private ? (
                <TimePicker
                  label="שעה"
                  value={hour ? moment(hour) : null}
                  onChange={onChangeMinutes}
                  renderInput={(params) => (
                    <TextField {...params} className="dateInput" error={false} />
                  )}
                />
              ) : null}
            </Stack>
          </LocalizationProvider>
        </>}

    </div>
  );
};

export default DateHour;
